var map = {
	"./ceciliapescao/logo.jpg": "541a",
	"./cerotranque/logo.jpg": "a698",
	"./demo/logo.jpg": "d097",
	"./enid/logo.jpg": "a6e5",
	"./garageburgers/logo.jpg": "bc50",
	"./lasalle/logo.jpg": "aa7c",
	"./lavillafood/logo.jpg": "0d13",
	"./madamecoco/logo.jpg": "325c",
	"./panamahotdog/logo.jpg": "e540",
	"./specialoneburger/logo.jpg": "64f0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b27e";